import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n';

export default function HreflangTags() {
  const location = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    // Set html lang attribute
    document.documentElement.lang = lang;

    // Clean existing hreflang links
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());

    const base = window.location.origin;
    const path = location.pathname;

    // Add hreflang links
    const frLink = document.createElement('link');
    frLink.rel = 'alternate';
    frLink.hreflang = 'fr';
    frLink.href = `${base}${path}`;
    document.head.appendChild(frLink);

    const enLink = document.createElement('link');
    enLink.rel = 'alternate';
    enLink.hreflang = 'en';
    enLink.href = `${base}${path}`;
    document.head.appendChild(enLink);

    const esLink = document.createElement('link');
    esLink.rel = 'alternate';
    esLink.hreflang = 'es';
    esLink.href = `${base}${path}`;
    document.head.appendChild(esLink);

    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `${base}${path}`;
    document.head.appendChild(defaultLink);

    return () => {
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
    };
  }, [lang, location.pathname]);

  return null;
}
